var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8438 18.75C30.8438 12.2779 25.5971 7.03125 19.125 7.03125C12.6529 7.03125 7.40625 12.2779 7.40625 18.75C7.40625 24.5991 11.6916 29.4473 17.2939 30.3264V22.1375H14.3185V18.75H17.2939V16.1682C17.2939 13.2312 19.0435 11.6089 21.7203 11.6089C23.002 11.6089 24.3435 11.8378 24.3435 11.8378V14.7217H22.8658C21.4102 14.7217 20.9561 15.6251 20.9561 16.5527V18.75H24.2062L23.6866 22.1375H20.9561V30.3264C26.5584 29.4473 30.8438 24.5991 30.8438 18.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.ed082bd62f3b88391a43396624b1dd02.svg";
export { ForwardRef as ReactComponent };